import { HttpClient } from "@angular/common/http";
import { constantvalues } from "../../const";
import { Injectable } from "@angular/core";
import { environment } from '../environments/environment.development'

@Injectable({
    providedIn: 'root'
})

export class ForgotPasswordService{
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl; 
    }

    forgotPassword(userDetails: any){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.FORGOT_PASSWORD_FOR_ACCOUNT_ADMIN}`, userDetails);
    }
}